<template>
  <DescriptionSection>
    <DescriptionItem title="Numer lokomotywy" :value="service.locomotives[0].sideNumber"></DescriptionItem>
  </DescriptionSection>
</template>

<script>
import DescriptionSection from '@/component/Description/description-section';
import DescriptionItem from '@/component/Description/description-item';

export default {
  name: 'LocomotiveControlReviewDetails',
  components: {
    DescriptionSection,
    DescriptionItem,
  },
  props: {
    service: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
